export const queryOne = (selector, root = document) => root.querySelector(selector);
export const queryAll = (selector, root = document) => root.querySelectorAll(selector);
